module.exports = __webpack_public_path__ + "img/certificate.85541c00.png";